<template>
  <nav class="navbar navbar-expand-lg navbar-dark shadow-sm">
    <div class="container-fluid">
      <a class="navbar-brand fw-bold d-flex align-items-center" href="/">
        <i class="fas fa-building me-2"></i>
        翼鸿房产营销管家
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div id="navbarContent" class="collapse navbar-collapse">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <RouterLink to="/" class="nav-link">
              <i class="fas fa-tachometer-alt me-1"></i>
              仪表板
            </RouterLink>
          </li>
          <li class="nav-item dropdown">
            <a
              id="customersDropdown"
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fas fa-users me-1"></i>
              客户管理
            </a>
            <ul class="dropdown-menu" aria-labelledby="customersDropdown">
              <li>
                <RouterLink to="/customers" class="dropdown-item">
                  <i class="fas fa-list me-2"></i>
                  客户列表
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/customers/create" class="dropdown-item">
                  <i class="fas fa-plus-circle me-2"></i>
                  添加客户
                </RouterLink>
              </li>
              <!-- <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" href="/reports/overdue">
                  <i class="fas fa-exclamation-triangle me-2"></i>
                  逾期客户
                </a>
              </li> -->
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              id="propertiesDropdown"
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fas fa-home me-1"></i>
              房源管理
            </a>
            <ul class="dropdown-menu" aria-labelledby="propertiesDropdown">
              <li>
                <RouterLink to="/properties" class="dropdown-item">
                  <i class="fas fa-list me-2"></i>
                  房源列表
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/properties/create" class="dropdown-item">
                  <i class="fas fa-plus-circle me-2"></i>
                  添加房源
                </RouterLink>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <RouterLink to="/properties/sales-control" class="dropdown-item">
                  <i class="fas fa-chart-line me-2"></i>
                  销控表
                </RouterLink>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              id="transactionsDropdown"
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fas fa-file-contract me-1"></i>
              交易管理
            </a>
            <ul class="dropdown-menu" aria-labelledby="transactionsDropdown">
              <li>
                <RouterLink to="/transactions" class="dropdown-item">
                  <i class="fas fa-list me-2"></i>
                  交易列表
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/transactions/create" class="dropdown-item">
                  <i class="fas fa-plus-circle me-2"></i>
                  创建交易
                </RouterLink>
              </li>
              <!-- <li><hr class="dropdown-divider"></li>
              <li>
                <RouterLink to="/transactions/stages" class="dropdown-item">
                  <i class="fas fa-bookmark me-2"></i>
                  交易阶段
                </RouterLink>
              </li> -->
            </ul>
          </li>
          <!-- <li class="nav-item dropdown">
            <a
              id="reportsDropdown"
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fas fa-chart-bar me-1"></i>
              报表分析
            </a>
            <ul class="dropdown-menu" aria-labelledby="reportsDropdown">
              <li>
                <RouterLink to="/reports" class="dropdown-item">
                  <i class="fas fa-th-large me-2"></i>
                  综合报表
                </RouterLink>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <RouterLink to="/reports/customers" class="dropdown-item">
                  <i class="fas fa-users me-2"></i>
                  客户统计
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/reports/properties" class="dropdown-item">
                  <i class="fas fa-building me-2"></i>
                  房源统计
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/reports/transactions" class="dropdown-item">
                  <i class="fas fa-handshake me-2"></i>
                  交易统计
                </RouterLink>
              </li>
            </ul>
          </li> -->

          <!-- Admin only menu items -->
          <template v-if="isAdmin">
            <li class="nav-item dropdown">
              <a
                id="adminDropdown"
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fas fa-cog me-1"></i>
                系统管理
              </a>
              <ul class="dropdown-menu" aria-labelledby="adminDropdown">
                <li>
                  <RouterLink to="/users" class="dropdown-item">
                    <i class="fas fa-user-cog me-2"></i>
                    用户管理
                  </RouterLink>
                </li>
                <li>
                  <RouterLink to="/agent-review" class="dropdown-item">
                    <i class="fas fa-user-check me-2"></i>
                    经纪人审核
                  </RouterLink>
                </li>
                <!-- <li><hr class="dropdown-divider"></li>
                <li>
                  <RouterLink to="/settings" class="dropdown-item">
                    <i class="fas fa-sliders-h me-2"></i>
                    系统设置
                  </RouterLink>
                </li> -->
              </ul>
            </li>
          </template>
        </ul>

        <!-- User menu -->
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a
              id="userDropdown"
              class="nav-link dropdown-toggle d-flex align-items-center"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                :src="currentUser?.avatar || '/images/default-avatar.jpg'"
                alt="User Avatar"
                class="rounded-circle me-2"
                width="32"
                height="32"
              />
              <span class="d-none d-md-inline">{{ currentUser?.username }}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <!-- <li>
                <a class="dropdown-item" href="#" @click.prevent="showProfileModal">
                  <i class="fas fa-user me-2"></i>
                  个人资料
                </a>
              </li>
              <li>
                <RouterLink to="/settings" class="dropdown-item">
                  <i class="fas fa-cog me-2"></i>
                  设置
                </RouterLink>
              </li>
              <li><hr class="dropdown-divider"></li> -->
              <li>
                <a class="dropdown-item text-danger" href="#" @click.prevent="handleLogout">
                  <i class="fas fa-sign-out-alt me-2"></i>
                  退出登录
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import logger from '@/utils/logger'

export default {
  name: 'NavbarComponent',
  setup() {
    const store = useStore()
    const router = useRouter()
    const toast = useToast()

    const currentUser = computed(() => store.state.auth.user)
    const isAdmin = computed(() => store.getters['auth/isAdmin'])

    const handleLogout = async () => {
      try {
        await store.dispatch('auth/logout')
        router.push('/login')
        toast.success('已安全退出登录')
      } catch (error) {
        toast.error('退出登录失败')
      }
    }

    const showProfileModal = () => {
      // Implement modal opening logic
      logger.log('Show profile modal')
    }

    return {
      currentUser,
      isAdmin,
      handleLogout,
      showProfileModal
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  background: linear-gradient(90deg, #2E8B57 0%, #1e7e34 100%) !important;
  margin-bottom: 0;
}

.nav-link {
  color: rgba(255, 255, 255, 0.85) !important;
  &:hover {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 0.375rem;
  }
}

.dropdown-menu {
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.125);
  > li > * {
    border-radius: 0.25rem;
    margin: 0.25rem;
  }
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
}
</style>